import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/resultCardMatchday.css';
import {getFormattedCurrency, getText, usingNonDecimalCurrency} from '../../../helpers/localization';
import {HARD_SUSPENDED, MAD, RES, RSD} from "../../../constants/identifiers";
// helpers
import {roundNumber, roundNumberForCurrency} from "../../../helpers/mathFunctions";
import {getAllWrappedMatchdayBets} from '../helpers/betHelpers';
//actions
import {MATCHDAY_MODULE_TYPE} from "../modules/matchday/constants/identifiers";
import {calculateTimeDifference} from '../../../helpers/helperFunctions';
import {BASE_VALUE} from '../../../constants/chips';
import {getPotentialReturn, getRoundedOdds} from '../modules/matchday/helpers/matchdayHelper';


const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedGameIndex: state.vpp.selectedGameIndex,
        systemLanguage: state.vpp.systemLanguage,
        serverTimeOffset: state.vpp.serverTimeOffset,
        channelEventBets: state.vpp.channelEventBets
    };
};

class ResultCardMatchday extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games,
            events: storeData.vpp.events,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            systemLanguage: storeData.vpp.systemLanguage,
            channelEventBets: storeData.vpp.channelEventBets,
            serverTimeOffset: storeData.vpp.serverTimeOffset
        };
    }

    componentDidMount() {
        this.interval = setInterval(() => this.setState({time: Date.now()}), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                games: storeData.vpp.games,
                events: storeData.vpp.events,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                systemLanguage: storeData.vpp.systemLanguage,
                channelEventBets: storeData.vpp.channelEventBets,
                serverTimeOffset: storeData.vpp.serverTimeOffset
            });
        }
    }

    _getMatchdayEventLiveScore(matchdayEvent) {
        let goalTimings = this.state.games[this.state.selectedGameIndex].goalTimings;

        let timeDiff = calculateTimeDifference(matchdayEvent.eventTime, new Date(Date.now() - this.state.serverTimeOffset));

        let selectedEventGoals = goalTimings !== undefined ? goalTimings.filter(goalTiming => (parseInt(goalTiming.eventID, 10) === matchdayEvent.eventId)
            && parseInt(goalTiming.timeMs, 10) < parseInt(timeDiff, 10)) : undefined;

        let score;
        if (selectedEventGoals === undefined || selectedEventGoals.length < 1)
            score = "0-0";
        else {
            score = selectedEventGoals[selectedEventGoals.length - 1].score;
        }
        if (this.state.games[this.state.selectedGameIndex].controllerState !== undefined
            && this.state.games[this.state.selectedGameIndex].controllerState[matchdayEvent.order] !== undefined
            && this.state.games[this.state.selectedGameIndex].controllerState[matchdayEvent.order] === RES) {
            score = score;
        }

        return score;
    }

    _getPotentialReturns(bonusPercentage, stake, odds, multiplier, promoValue=0) {
        let potentialReturns = getPotentialReturn(odds, stake, multiplier, bonusPercentage,promoValue);

        if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
            potentialReturns = Math.round(potentialReturns);
        }
        return potentialReturns;
    }

    render() {
        if (this.state.games[this.state.selectedGameIndex].type === MATCHDAY_MODULE_TYPE && this.state.selectedEventIndex === 0) {
            let matchdayEvents = this.state.events[0];
            if (matchdayEvents !== undefined) {
                let totalReturns = 0;
                let returnsText;
                let prizeAmount;
                let lookForTheText;
                let nextScheduledText;
                let eventText;

                if (this.state.games[this.state.selectedGameIndex].isResultShowing
                    && this.state.games[this.state.selectedGameIndex].lastResult !== undefined
                    && this.state.games[this.state.selectedGameIndex].lastResult.length === 8) {
                    let completeBets = [];
                    let systemCurrency = this.props.store.getState().vpp.systemCurrency;
                    let matchdayBets = getAllWrappedMatchdayBets(this.state, matchdayEvents.channel).filter(
                        (pBet) => matchdayEvents.some(selectedMatchdayEvent => pBet.Bets[0].EventId === selectedMatchdayEvent.eventId.toString()
                                && this.state.games[this.state.selectedGameIndex].lastResult.some((evt) => evt.eventId === selectedMatchdayEvent.eventId.toString()))
                            && pBet.Bets[0].Channel === matchdayEvents[0].channel
                    );
                    // only add the active bets to the array if game isn't hard suspended.
                    // Hard suspension do not pay the bet when settled
                    if (this.state.games[this.state.selectedGameIndex].state !== HARD_SUSPENDED) {
                        completeBets = matchdayBets.slice();
                    }

                    completeBets.forEach((bet) => {
                        if (bet.Bets.length === 1) {
                            let event = this.state.games[this.state.selectedGameIndex].lastResult.find((evt) => evt.eventId === bet.Bets[0].EventId);
                            let eventResult = event.result.split(',');
                            if (eventResult.includes(bet.Bets[0].Market.Id)) {
                                let stake = usingNonDecimalCurrency(systemCurrency) ? roundNumber(bet.Bets[0].Stake, 2) : roundNumber(bet.Bets[0].Stake / BASE_VALUE, 2);
                                if (Number(stake) && Number(bet.Bets[0].Market.Price)) {
                                    let currentReturn = roundNumberForCurrency(this._getPotentialReturns(0, stake, bet.Bets[0].Market.Price, 1), systemCurrency);
                                    //promobet logic 
                                    if(!(bet.Bets[0].PromoId === 'real_bet')){
                                        currentReturn = roundNumberForCurrency(this._getPotentialReturns(0, stake, bet.Bets[0].Market.Price, 1,stake), systemCurrency);
                                    }
                                    totalReturns = totalReturns + roundNumberForCurrency(currentReturn, systemCurrency);
                                }
                            }
                        } else {
                            if (bet.Bets.every(bt => {
                                let event = this.state.games[this.state.selectedGameIndex].lastResult.find((evt) => evt.eventId === bt.EventId);
                                let eventResult = event.result.split(',');
                                if (!eventResult.includes(bt.Market.Id)) {
                                    return false;
                                }
                                return true;
                            })) {
                                let multiplier = bet.Multiplier;
                                let stake = bet.Bets[0].Stake / multiplier;
                                let odds = getRoundedOdds(bet.Bets, false);
                                let potentialReturns = (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) ? this._getPotentialReturns(bet.Bonus, stake, odds, multiplier) : this._getPotentialReturns(bet.Bonus, stake / BASE_VALUE, odds, multiplier);
                                //let currentReturn = roundNumber(parseFloat(potentialReturns)*multiplier,2).toFixed(2);
                                //promobet logic 
                                if(!(bet.Bets[0].PromoId === 'real_bet')){
                                    potentialReturns = this._getPotentialReturns(bet.Bonus, stake / BASE_VALUE, odds, multiplier, stake / BASE_VALUE);
                                }
                                totalReturns = totalReturns + Number((usingNonDecimalCurrency(systemCurrency) ? potentialReturns : potentialReturns));
                            }
                        }
                    });
                    if (totalReturns !== 0) {
                        returnsText = (<div
                            className={systemCurrency === RSD || systemCurrency === MAD ? style.winTextNonSymbolCurrency : style.win}>{getText('RETURNS', this.props.store)}</div>);
                        prizeAmount = (<div
                            className={systemCurrency === RSD || systemCurrency === MAD ? style.winTextNonSymbolCurrency : style.win}>{getFormattedCurrency(this.props.store, totalReturns, 2)}</div>);

                    } else {
                        lookForTheText = (
                            <div className={style.lose}>{getText('LOOK_FOR_THE', this.props.store)}</div>);
                        nextScheduledText = (
                            <div className={style.lose}>{getText('NEXT_SCHEDULED', this.props.store)}</div>);
                        eventText = (<div className={style.lose}>{getText('EVENT', this.props.store)}</div>);
                    }
                }

                let scoreBoard = matchdayEvents.map((event, index) => {
                    return (<div className={style.eventContainer} key={index}>
                        <div className={style.team}>
                            <b>
                                {getText('Matchday_' + event.teamOne, this.props.store)}
                            </b>
                        </div>
                        <div className={style.score}>
                            {this._getMatchdayEventLiveScore(event)}
                        </div>
                        <div className={style.team}>
                            <b>
                                {getText('Matchday_' + event.teamTwo, this.props.store)}
                            </b>
                        </div>
                        <div className={style.timer}>
                            <b>
                                {!this.state.games[this.state.selectedGameIndex].isResultShowing && this.state.games[this.state.selectedGameIndex].controllerState != undefined
                                && this.state.games[this.state.selectedGameIndex].controllerState[index + 1] === RES ? getText('FT', this.props.store) : ''}
                            </b>
                        </div>
                    </div>);
                });
                return (
                    <div>
                        <div className={style.mainContainer}>
                            {scoreBoard}
                        </div>
                        <div className={style.rightContainer}>
                            {returnsText}
                            {prizeAmount}
                            {lookForTheText}
                            {nextScheduledText}
                            {eventText}
                        </div>
                    </div>
                );
            } else {
                return '';
            }
        } else {
            return '';
        }
    }
}

export default connect(mapStateToProps)(ResultCardMatchday);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/resultCardMatchday.js